// InvoiceLogo.tsx
// Displays the logo of the company on the invoice.

import React from "react";

import LogoImage from "../../../../assets/img/bitmaker-logo.jpg";

export const InvoiceLogo: React.FC = () => {
  return (
    <div className="py-8 border-b border-gray-200">
      <div className="text-center">
        <img
          src={LogoImage}
          alt="Bitmaker Logo"
          className="mx-auto block max-w-full h-auto max-h-24"
        />
      </div>
    </div>
  );
};
